import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { columnDefs, defaultColDef } from './utils/definitions-config';
import { getFilteredUserReferEarn } from '../../services/apiService';
import _, { debounce } from 'lodash';
import moment from 'moment';
import EnrollmentTable from './utils/enrollmentTable';
import RewardsTable from './utils/rewardsTable';
import { getFullName } from '../../utils';
import AddReferrer from './utils/addRefer';
import { Tooltip } from '@material-ui/core';
import { v4 } from 'uuid';

const getServerSideDatasource = (server) => {
  return {
    getRows: debounce((params) => {
      const filterData = {};
      const sortData = {};
      const paginationData = {};

      if (params.request) {
        const { startRow, endRow, filterModel, sortModel } = params.request;
        // sorting
        if (sortModel.length > 0) {
          sortData.column = sortModel[0].colId;
          sortData.order = sortModel[0].sort.toUpperCase();
        }
        // filter
        const filterKeys = Object.keys(filterModel);
        filterKeys.forEach((key, index) => {
          if (
            key !== 'userName' &&
            key !== 'emailId' &&
            key !== 'referralUrl' &&
            key !== 'noOfSignups' &&
            key !== 'noOfEnrolments' &&
            key !== 'redeemed'
          ) {
            filterDataEnteries(key, filterData, filterModel[key]);
          }
        });
        // pagination
        if (endRow) {
          paginationData.start = startRow;
          paginationData.end = endRow;
        }
      }

      // outer filter applicaple when filterModel is empty
      if (server?.length > 0 && typeof server === 'string') {
        filterData.userId = server;
      }
      const computedData = {
        filter: filterData,
        // sort: sortData,
        pagination: paginationData,
      };
      if (sortData.column) {
        computedData.sort = sortData;
      }
      if (Object.keys(computedData.filter).length > 0) {
        getFilteredUserReferEarn(computedData)
          .then((res) => {
            params.successCallback(
              res?.data || [res] || [],
              res?.pagination?.totalCount || res?.data?.length || 1
            );
          })
          .catch((error) => {
            console.error(error);
            params.failCallback();
          });
      } else {
        try {
          params.successCallback([], 0);
        } catch (error) {
          console.error(error);
          params.failCallback();
        }
      }
    }, 1000),
  };
};

const filterDataEnteries = (key, obj, data) => {
  switch (key) {
    case 'createdAt':
      obj[key] = [
        moment(data?.dateFrom).toISOString(),
        moment(data?.dateTo).toISOString(),
      ];
      break;
    case 'referralAmount':
      if (data.type === 'equals') {
        obj[key] = [data?.filter * 100, data?.filter * 100];
      } else if (data.type === 'lessThan') {
        obj[key] = obj[key] = [null, data?.filter * 100];
      } else if (data.type === 'greaterThan') {
        obj[key] = obj[key] = [data?.filter * 100, null];
      } else obj[key] = [data?.filter * 100, data?.filterTo * 100];
      break;
    case 'lifetimeRewards':
      if (data.type === 'equals') {
        obj[key] = [data?.filter * 100, data?.filter * 100];
      } else if (data.type === 'lessThan') {
        obj[key] = obj[key] = [null, data?.filter * 100];
      } else if (data.type === 'greaterThan') {
        obj[key] = obj[key] = [data?.filter * 100, null];
      } else obj[key] = [data?.filter * 100, data?.filterTo * 100];
      break;
    default:
      obj[key] = data?.filter;
  }
};

function ReferEarnTable({ rowData, date }) {
  const [gridApi, setGridApi] = React.useState(null);
  const ref = React.useRef();

  React.useEffect(() => {
    if (gridApi) {
      onGridReady(gridApi, rowData);
    }
  }, [rowData]);

  const onGridReady = React.useCallback((params, data) => {
    setGridApi(params);
    const datasource = getServerSideDatasource(data);
    params.api.setServerSideDatasource(datasource);
  }, []);

  const EnrollmentsData = (params) => {
    const [showEnrollmetTable, setShowEnrollmetTable] = React.useState(false);
    const enrolledUsers = params?.data?.referredUsers.filter(
      (user) => user.enrolledCourseType
    );
    const name = getFullName(params?.data?.userDetail) || '';
    return (
      <span
        className='text-blue-500 cursor-pointer'
        onClick={() => setShowEnrollmetTable(true)}
      >
        {!showEnrollmetTable ? (
          enrolledUsers?.length
        ) : (
          <EnrollmentTable
            show={setShowEnrollmetTable}
            rowData={enrolledUsers}
            dialogOpen={showEnrollmetTable}
            name={name}
          />
        )}
      </span>
    );
  };

  const GiftCardData = (params) => {
    const [showGiftCardTable, setShowGiftCardTable] = React.useState(false);
    const vouchers = _.cloneDeep(params?.data?.referralVoucherOrders) || [];
    const giftCardName = vouchers.map((giftCard) => {
      return giftCard.productName;
    });

    const giftCardNameList = vouchers.map((i) =>
      i.vouchers.map((j) => ({
        ...j,
        image: i.imageUrl,
        amountCharged: i.amountCharged,
        productName: i.productName,
        referenceId: i.orderId,
        denomination: i.denomination,
        quantity: i.quantity,
        status: i.orderStatus,
      }))
    );
    const flatData = giftCardNameList.flat();

    const name = getFullName(params?.data?.userDetail) || '';
    let giftCardFirstName = giftCardName.length > 0 ? giftCardName?.[0] : '-';
    if (giftCardName.length > 1) {
      giftCardFirstName +=
        ', ' + '+' + JSON.stringify(flatData.length - 1) + ' more';
    }
    return (
      <span
        className='text-blue-500 cursor-pointer'
        onClick={() => setShowGiftCardTable(true)}
      >
        {!showGiftCardTable ? (
          giftCardFirstName
        ) : (
          <RewardsTable
            show={setShowGiftCardTable}
            rowData={flatData}
            dialogOpen={showGiftCardTable}
            userGroup={params?.data?.userGroup || ''}
            name={name}
          />
        )}
      </span>
    );
  };

  const NameGetter = (params) => {
    const [edit, setEdit] = React.useState(false);
    const userName = getFullName(params.data.userDetail) || '';

    return (
      <>
        <AddReferrer
          setEdit={setEdit}
          edit={edit}
          params={params}
          heading='Update Referrer'
          id={v4()}
          onUpdateSelected={onUpdateSelected}
        />
        <Tooltip title='Click to update referrer details'>
          <div onClick={() => setEdit(true)} className='cursor-pointer'>
            <span>{userName}</span>
          </div>
        </Tooltip>
      </>
    );
  };

  const onUpdateSelected = () => {
    ref.current.api.onFilterChanged();
  };

  const frameworkComponents = {
    enrollmentTable: EnrollmentsData,
    giftCardTable: GiftCardData,
    nameGetter: NameGetter,
  };

  return (
    <div className='ag-theme-alpine z-50' style={{ width: '100%' }}>
      <AgGridReact
        ref={ref}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        tooltipShowDelay={0}
        tooltipHideDelay={2000}
        onGridReady={onGridReady}
        domLayout='autoHeight'
        rowModelType='serverSide'
        rowHeight={50}
        serverSideStoreType='partial'
        animateRows={true}
        frameworkComponents={frameworkComponents}
        serverSideInfiniteScroll={true}
        pagination={true}
        paginationPageSize={10}
        cacheBlockSize={10}
      />
    </div>
  );
}

export default ReferEarnTable;
